<template>
  <div class="game-history-container">

    <div class="slider-container">
      <div class="game-history-slider" ref="slider">

        <div
          class="history-item"
          v-for="(item, index) in duplicatedHistory"
          :key="index"
        >
          <!-- SOL: Oyun ikonu -->
          <img
            :src="item.game.banner"
            :alt="item.game.game_name"
            class="game-icon"
          />

          <!-- SAĞ: Username + Profit -->
          <div class="right-content">
            <div class="username">{{ item.user.username }}</div>

            <div class="profit-row">
              <img src="@/assets/img/coin.png" class="coin-icon" />
              <span class="profit-value">{{ formatNumber(item.profit) }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>


<script setup>
import { ref, onMounted, computed, nextTick } from "vue";
import axios from "axios";

const history = ref([]);
const slider = ref(null);

// Infinite loop data duplication
const duplicatedHistory = computed(() => [...history.value, ...history.value]);

const formatNumber = (num) =>
  new Intl.NumberFormat("tr-TR").format(num);

onMounted(async () => {
  const res = await axios.get("/gamehistory2/game-history");
  if (res.data?.success) {
    history.value = res.data.data;
  }

  await nextTick();
  autoScroll();
});

function autoScroll() {
  const el = slider.value;
  if (!el) return;

  let speed = 0.25;
  let accumulator = 0;

  function loop() {
    accumulator += speed;
    const move = Math.floor(accumulator);
    accumulator -= move;

    el.scrollLeft += move;

    if (el.scrollLeft >= el.scrollWidth / 2) {
      el.scrollLeft = 0;
    }

    requestAnimationFrame(loop);
  }

  loop();
}
</script>

<style scoped>
/* WRAPPER */
.game-history-container {
  width: 100%;
   
}

/* SLIDER */
.slider-container {
  width: 100%;
  overflow: hidden;
}

.game-history-slider {
  display: flex;
  gap: 12px;
  white-space: nowrap;
  overflow-x: hidden;
  padding: 8px 4px;
}

/* === YATAY KART === */
.history-item {
  display: flex;
  align-items: center;
  gap: 10px;

  background: var(--background2);
  
  border-radius: 10px;

  padding: 6px 10px;
  flex-shrink: 0;

  width: 160px;      /* 🔥 Görseldeki ile aynı */
  height: 48px;

  cursor: pointer;
  transition: 0.25s ease;
}

 

/* SOL ICON */
.game-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;   /* kare-oval görüntü */
  object-fit: cover;
}

/* SAĞ TARAF */
.right-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.1;
}

/* Username */
.username {
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  max-width: 90px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Profit Row */
.profit-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.coin-icon {
  width: 14px;
  height: 14px;
}

.profit-value {
  font-size: 13px;
  font-weight: 700;

  color: #fbbf24; /* sarımsı altın tonu */
}

/* Responsive */
@media (max-width: 600px) {
  .history-item {
    width: 150px;
    height: 44px;
  }
  .game-icon {
    width: 34px;
    height: 34px;
  }
}
</style>

